import { ALERT_TYPES } from '../actionTypes';

export function alert(state = { inProgress: false }, action) {
  switch (action.type) {
    case ALERT_TYPES.SUCCESS:
      if (!state.inProgress)
        return {
          severity: 'success',
          message: action.message,
          inProgress: true
        };
        return state
    case ALERT_TYPES.ERROR:
      if (!state.inProgress)
        return {
          severity: 'error',
          message: action.message,
          inProgress: true
        };

      return state
    case ALERT_TYPES.INFO:
      return {
        severity: 'info',
        message: action.message,
        inProgress: true
      };
    case ALERT_TYPES.CLEAR: {
      return {
        ...state,
        inProgress: false,
      }
    }
    default:
      return state
  }
}
